"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigate = exports.NavigateProvider = exports.NavigateContext = void 0;
var react_1 = __importStar(require("react"));
var use_default_navigate_hook_1 = require("./use-default-navigate-hook");
var NavigateContext = (0, react_1.createContext)(null);
exports.NavigateContext = NavigateContext;
var NAVIGATE_CONTEXT_ERROR = "useNavigate couldn't access the NavigateContext object.\n\n  This might be due to\n    - useNavigate was used outside a parent NavigateContext\n    - there are multiple versions of ui-tools installed and NavigateContext was imported from a different one\n";
function useNavigate() {
    var useNavigateHook = (0, react_1.useContext)(NavigateContext);
    if (useNavigateHook === null) {
        throw new Error(NAVIGATE_CONTEXT_ERROR);
    }
    return useNavigateHook();
}
exports.useNavigate = useNavigate;
function NavigateProvider(_a) {
    var children = _a.children, useNavigateHook = _a.useNavigateHook;
    var contextValue = useNavigateHook || use_default_navigate_hook_1.useDefaultNavigateHook;
    return (react_1.default.createElement(NavigateContext.Provider, { value: contextValue }, children));
}
exports.NavigateProvider = NavigateProvider;
